<!--
 * @Author: DY
 * @Date: 2024-11-21 14:41:15
 * @LastEditTime: 2025-04-28 16:29:50
 * @Description: 物资退库入库申请【仓储管理】
 * @FilePath: \ShiMo_Mobile\src\views\storage\instockReturnApply\index.vue
-->
<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="instockReturnApply commonListStyles">
            <HeaderNav
                left-icon-name="2"
                right-icon-name="5"
                header-title="物资退库入库"
                :extr="{ leftCallBack: swiperright, rightCallBack: openWarehouseReceipt, iconName: 'sm-icon-test' }"
            ></HeaderNav>
            <section>
                <van-search v-model="keyVal" placeholder="请输入搜索信息" @change="onRefresh"></van-search>
                <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
                    <van-list v-model="isUpLoading" finished-text="没有更多了!" :finished="finished" @load="onLoad">
                        <ul class="list">
                            <li class="listItem" v-for="(item,index) in listData" :key="`item_${index}`">
                                <div class="engineeringInfo">
                                    <template v-for="s in StatusData">
                                        <span :style="`background: ${s.bg_color}`" :key="s.value" class="itemStatus" v-if="item.status === s.value">
                                            {{ s.name }}
                                        </span>
                                    </template>
                                    <h4 class="itemTitle">
                                        <span class="iconfont iconhetong">退库入库编号：{{ item.instock_number }}</span>
                                    </h4>
                                    <div class="itemContent">
                                        <p>
                                            <img src="@/assets/images/icons/icon_28@2x.png" alt="">
                                            <span>来源单据编号：{{ item.outstock_number }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_46@2x.png" alt="">
                                            <span>申请人：{{ item.apply_user_name }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_34@2x.png" alt="">
                                            <span>申请时间：{{ item.apply_time }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_47@2x.png" alt="">
                                            <span>仓库名称：{{ item.outstock_number }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_8@2x.png" alt="">
                                            <span>库管员：{{ item.storeman_name }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_7@2x.png" alt="">
                                            <span>入库时间：{{ item.InstockTime }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_10@2x.png" alt="">
                                            <span>备注：{{ item.Remarks }}</span>
                                        </p>
                                    </div>
                                    <div class="itemBtn itemBtns">
                                        <template v-if="item.status == 0">
                                            <button @click="openWarehouseReceipt(item, 'edit')">
                                                编辑
                                            </button>
                                            <button @click="submitFun(item)">
                                                提交
                                            </button>
                                            <button @click="deleteFun(item)">
                                                删除
                                            </button>
                                        </template>
                                        <button v-else @click="openWarehouseReceipt(item, 'see')">
                                            查看
                                        </button>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </van-list>
                </van-pull-refresh>
            </section>
        </div>
    </v-touch>
</template>

<script>
import { mixin_list } from '@/assets/mixin/mixin_list';
export default {
    name: 'instock-return-apply',
    mixins: [mixin_list],
    beforeRouteLeave(to, from, next) {
        if (to.path === '/home') {
            this.$store.commit('noKeepAlive', 'instock-return-apply');
        }
        next();
    },
    data() {
        return {
            tableCode: 'instock_return_apply',
            StatusData: [
                {
                    name: '待提交',
                    value: 0,
                    bg_color: '#F85B5B',
                },
                {
                    name: '待审核',
                    value: 1,
                    bg_color: '#F85B5B',
                },
                {
                    name: '待入库',
                    value: 2,
                    bg_color: '#F85B5B',
                },
                {
                    name: '已入库',
                    value: 3,
                    bg_color: '#F8985B',
                },
                {
                    name: '已作废',
                    value: 4,
                    bg_color: '#F8985B',
                },
            ],
        };
    },
    filters: {},
    computed: {},
    watch: {},
    activated() {
        if (this.$route.params.saveCallback) {
            this.onRefresh();
        }
    },
    created() {
        this.cacheKey = Math.floor(Math.random() * 1000000000000 + 1);
    },
    mounted() {},
    methods: {
        async submitFun(item) {
            this.$dialog.confirm({
                message: '确认要提交吗？',
            }).then(async () => {
                const data = await this.getApplyData(item.id);
                data.Status = 1;
                const url = '/interfaceApi/procurement/instock_return/instock_apply_save';
                const res = await this.saveApiData(url, data);
                if (res) {
                    this.$toast('提交成功！');
                    this.onRefresh();
                }
            });

        },
        deleteFun(item) {
            this.$dialog.confirm({
                message: `确认删除退库入库单【${item.instock_number}】吗？`,
            }).then(async () => {
                const res = await this.deleteApplyData(item.id);
                if (res) {
                    this.$toast('删除成功！');
                    this.onRefresh();
                }
            });
        },
        openWarehouseReceipt(row = null, type = 'add') {
            const userId = this.$takeTokenParameters('Uid');
            this.$router.isBack = 2;
            let listType = 1;
            if (!row) {
                listType = 1;
            } else if (row.status === 0) {
                listType = 0;
            } else if (row.status === 1) {
                listType = 2;
            } else if (row.status === 2 && row.storeman_id === userId) {
                listType = 3;
            } else if (row.status === 3 && row.storeman_id === userId) {
                listType = 3;
            } else if (row.status === 2 && row.manager_id === userId) {
                listType = 2;
            } else if (row.status === 3 && row.manager_id === userId) {
                listType = 2;
            }
            this.$router.push({ name: 'instockReturnApplyForm', params: { type, listType, data: row } });
        },
        // 获取详情
        getApplyData(id = '3a15ace9-929d-6bca-2340-51ade519ca1b') {
            return this.$axios.$get(`/interfaceApi/procurement/instock_return/instock_single?id=${id}`, { defEx: true });
        },
        // 保存申请数据
        saveApiData(url, requestData) {
            const data = requestData;
            return this.$axios.$post(url, data, { defEx: true });
        },
        // 删除退库入库单
        deleteApplyData(id) {
            return this.$axios.$get(`/interfaceApi/procurement/instock_return/instock_delete?id=${id}`);
        },
    },
};
</script>
<style lang="stylus">
.instockReturnApply
    position relative
</style>
